import React from 'react';
import {
	Dimensions,
	View,
	StyleSheet,
	TouchableHighlight,
	useWindowDimensions,
} from 'react-native';
import moment from 'moment';
import colors from '../../../config/colors';
import I18n from '../../../components/shared/i18n/I18n.component';
import Header from '../../../components/shared/Header/Header.container';
import WebHeader from '../../../components/shared/Header/WebHeader.component';
import ReportsPageWrapper from '../../../components/web/ReportsPageWrapper/ReportsPageWrapper.component';
import TableContainer from '../../../components/web/ReactTable/Table.container';
import { Columns } from './EmployeeHoursReportSummary.utils';
import getShadowStyle from '../../../config/shadow';
import Typography from '../../../components/shared/Typography/Typography.component';
import { i18nService } from '../../../services/i18n.service';
import Filters from '../../../components/web/Filters/Filters.component';
import { opacity } from 'html2canvas/dist/types/css/property-descriptors/opacity';
import ImageIcon from '../../../components/shared/Icon/ImageIcon.component';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import ButtonV2 from '../../../components/shared/Buttons/ButtonV2.container';
const clockInLogo = require('../../../../assets/images/clockLogo/michpal_clock_in.png');

export interface Props {
	navigation: any;
	data: any[];
	onSort?: any;
	currentEmployee: any;
	onLoadMore: any;
	totalData: any;
	filtersConfig: any;
	isSelectMode: boolean;
	selectedRows: any[];
	isAllSelected: boolean;
	onSelectAll: (cheacked: boolean) => {};
	onSelect: () => {};
	onConfirmSelect: () => {};
	onCancelSelect: () => {};
	reqForSelect: () => {};
	onFilter: () => {};
	OnPrevEmployeePress: () => {};
	OnNextEmployeePress: () => {};
	onDelete: (id: any) => {};
	onShowHistory: (row: object) => {};
	onEdit: (id: any) => {};
	reqForWorkLogREports: () => void;
	backToAllHoursReports: () => void;
	addReport: () => void;
	disableNextButton: boolean;
	worklogReportFormat: any;
	canEdit: boolean;
	businessUnitsList: any[];
}

const EmployeeHoursReportSummary = ({
	data,
	totalData,
	navigation,
	currentEmployee,
	onSort,
	onLoadMore,
	filtersConfig,
	isSelectMode,
	selectedRows,
	isAllSelected,
	disableNextButton,
	worklogReportFormat,
	addReport,
	backToAllHoursReports,
	reqForWorkLogREports,
	onSelectAll,
	onSelect,
	onConfirmSelect,
	onCancelSelect,
	reqForSelect,
	onFilter,
	OnPrevEmployeePress,
	OnNextEmployeePress,
	onEdit,
	onDelete,
	onShowHistory,
	canEdit,
	businessUnitsList,
}: Props) => {
	const { height: windowHeight } = useWindowDimensions();


	return (
		<View
			style={{
				height: '100%',
			}}
		>
			<Header
				navigation={navigation}
				containerStyle={{ backgroundColor: colors.white }}
				component={WebHeader}
			/>
			<ReportsPageWrapper
				navigation={navigation}
				title={
					<>
						<TouchableHighlight
								underlayColor='transparent'
								onPress={backToAllHoursReports}
								style={{ marginLeft: 8 }}
							>
							<ImageIcon name='chevronRight' color={colors.titlePrimary} width={20} height={20} />
						</TouchableHighlight>

						<View style={{ flexDirection: 'row-reverse', alignItems: 'center', marginLeft: 40 }}>
							<ImageIcon name="clockInLogo" width={108} height={30} style={{marginLeft: 12}} />
							<I18n
								size={20}
								weight='bold'
								color='primaryDarkBlue'
								style={{ flex: 4 }}
							>
								employeeHoursReport.title
							</I18n>
						</View>
			
						<View
							style={{
								display: 'flex',
								flexDirection: 'row-reverse',
								justifyContent: 'center',
								marginLeft: 40,
								alignItems: 'center'
							}}
						>
							<I18n
								size={20}
								weight='normal'
								color='clockRecordBlue'
								style={{ alignItems: 'center' }}
							>
								{currentEmployee.fullName}
							</I18n>
							<View style={{ width: 2, height: 20, backgroundColor: colors.clockGreyText, marginHorizontal: 12 }} />
							<I18n
								size={20}
								weight='normal'
								color='clockRecordBlue'
								style={{ alignItems: 'center' }}
							>
								{currentEmployee.teudatZeut}
							</I18n>
							
							{currentEmployee.finishWork ? (
								<View style={{ flexDirection: 'row-reverse' }}>
									<I18n
										size={12}
										// color='white'
										weight='normal'
										style={{ marginLeft: 5 }}
									>
										general.endWorkDate
									</I18n>
									<I18n size={12} weight='normal'>
										{moment(
											currentEmployee.finishWork,
											'YYYY-MM-DD',
										).format('DD/MM/YYYY')}
									</I18n>
								</View>
							) : null}
						</View>
						<View style={{ flex: 8, flexDirection: 'row-reverse' }}>
							<ButtonV2
								preset='link'
								onPress={() => OnPrevEmployeePress()}
								disabled={currentEmployee.itemIndex === 0 ? true : false}
								overrideStyle={{width: 'auto'}}
							>
								<>
									<I18n color='titlePrimary'>employeeHoursReport.prevButton</I18n>
									<ImageIcon name='chevronRight' style={{ marginLeft: 8 }} />
								</>
							</ButtonV2>
							<ButtonV2
								preset='link'
								onPress={() => OnNextEmployeePress()}
								disabled={disableNextButton}
								overrideStyle={{width: 'auto'}}
							>
								<>
									<ImageIcon name='chevronRight' style={{ marginRight: 8, transform: 'rotate(180deg)' }} />
									<I18n color='titlePrimary'>employeeHoursReport.nextButton</I18n>
								</>
							</ButtonV2>
						</View>

						<ButtonV2
								preset='primary'
								onPress={() => reqForWorkLogREports()}
								overrideStyle={{width: 'auto', marginLeft: 8}}
							>								
								<I18n color='white' weight='400' size={14}>hoursReport.toAllReports</I18n>				
							</ButtonV2>
						{isSelectMode ? (
							<View style={{ flexDirection: 'row', gap: 8 }}>
								<ButtonV2
									preset='primary'
									onPress={() => onConfirmSelect()}
									disabled={false}
								>
									<Typography
										color={'white'}
										weight='400'
										size={14}
									>
										{i18nService.translate('employeeHoursReport.confirmFilterButton')}
									</Typography>
								</ButtonV2>
								<ButtonV2
									preset='outline'
									onPress={() => onCancelSelect()}
									disabled={false}
								>
									<Typography
										color={'titlePrimary'}
										weight='400'
										size={14}
									>
										{i18nService.translate('employeeHoursReport.cancelFilterButton')}
									</Typography>
								</ButtonV2>
							</View>
						) : (						
							<ButtonV2
								preset='outline'
								onPress={reqForSelect}
								disabled={!canEdit}
								overrideStyle={{width: 'auto'}}
							>
								<Typography
									color={'titlePrimary'}
									weight='400'
									size={14}
								>
									{i18nService.translate(
										'employeeHoursReport.reqForConfirmButton',
									)}
								</Typography>
								<ImageIcon name='checkedMark' color={colors.titlePrimary } style={{ marginLeft: 8 }} width={12} height={12}/>
							</ButtonV2>
						)}
						{canEdit && (
							<ButtonV2 preset='primary' onPress={addReport} overrideStyle={{width: 'auto', marginRight: 10}}>
								<Typography color='white' weight='400' size={14}>
									{i18nService.translate('employeeHoursReport.addReport')}
								</Typography>
								<ImageIcon name='plus' color='white' style={{ marginLeft: 8 }} width={12} height={12} />
							</ButtonV2>
						)}
					</>
				}
				noHeader={true}
			>
				<View
					style={{
						flexDirection: 'row-reverse',
						width: '100%',
						justifyContent: 'space-between',
						zIndex: 100,
					}}
				>
					<View style={{ flexDirection: 'row-reverse' }}>
						<Filters
							config={filtersConfig}
							onChange={onFilter}
							customStyles={{
								container: {
									display: 'flex',
									flexDirection: 'row-reverse',
									justifyContent: 'flex-end',
									alignSelf: 'center',
								},
								filterContainer: {
									marginLeft: 10,
									marginVertical: 10,
									zIndex: 10001,
								},
							}}
						/>
					</View>
				</View>

				<View
					style={{
						maxHeight: windowHeight - 300,
					}}
				>
					<TableContainer
						keyName={''}
						headers={Columns(
							totalData ? totalData.total : null,
							isSelectMode,
							selectedRows,
							isAllSelected,
							onSelectAll,
							onSelect,
							onDelete,
							onShowHistory,
							onEdit,
							worklogReportFormat,
							canEdit,
							businessUnitsList,
						)}
						data={data || []}
						getNextData={onLoadMore}
						onSort={onSort}
						hasFooter={true}
						selectedRowId={0}
					/>
				</View>
			</ReportsPageWrapper>
		</View>
	);
};

const styles = StyleSheet.create({
	newRequestButton: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		height: 40,
		backgroundColor: colors.lightPrimary,
		borderRadius: 45,
		...getShadowStyle(20, 'rgb(59, 112, 164)'),
		marginTop: 10,
		marginLeft: 10,
	},
	fabButton: {
		borderRadius: 30,
		width: 40,
		height: 40,
		marginTop: 10,
		marginLeft: 10,
		...getShadowStyle(20, 'rgb(59, 112, 164)'),
	},
	nextEmpButton: {
		marginRight: 10,
		marginTop: 10,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		height: 40,
		paddingHorizontal: 5,
		backgroundColor: colors.lightPrimary,
		borderRadius: 10,
		...getShadowStyle(20, 'rgb(59, 112, 164)'),
	},
});

export default EmployeeHoursReportSummary;
